/**
 * Takes Firebases bullshit error messages and cleans them up 
 * based on the error code returned.
 */
export default function(code) {
    switch (code) {
        case "auth/user-not-found":
            return "User not found.";
        case "auth/wrong-password":
            return "Email or password incorrect";
        case "auth/user-not-verified":
            return "Your account has not been verified. Please verify your email before logging in.";
        case "auth/user-disabled":
            return "Your account has been disabled."
    }

    console.log(code);
    return "An error occurred but we're not sure what happened.";
}